import * as React from "react";
import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { useHotelsContext } from "components/flexComponents/Hotels/components/HotelsContext";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { egRecsClickstreamSelectedEvent } from "components/flexComponents/Hotels/utils/egRecsEvents";

export const useSendEgRecsClickstreamSelectedEvent = (hotel: Hotel, index: number) => {
  const { model } = useHotelsContext();
  const { strategy } = model;
  const track = useEgClickstream();

  return React.useCallback(() => {
    const event = egRecsClickstreamSelectedEvent(hotel, model, `${index}`);

    if (strategy === "EG_RECS") {
      track(event);
    }
  }, [hotel, index, track, strategy]);
};
